import installer from './defaults'

export * from '@pit-element-plus/components'
export * from '@pit-element-plus/constants'
export * from '@pit-element-plus/directives'
export * from '@pit-element-plus/hooks'
export * from './make-installer'

export const install = installer.install
export const version = installer.version
export default installer

export { default as dayjs } from 'dayjs'
